import { render, staticRenderFns } from "./MaydayWebUserAvatar.vue?vue&type=template&id=1f8b6968&scoped=true&"
import script from "./MaydayWebUserAvatar.vue?vue&type=script&lang=js&"
export * from "./MaydayWebUserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebUserAvatar.vue?vue&type=style&index=0&id=1f8b6968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b6968",
  null
  
)

export default component.exports